import * as Types from '../../../graphql/types.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInMutationVariables = Types.Exact<{
  input: Types.SignInInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'SignInResult', result?: { __typename?: 'AccessToken', accessToken: string } | null } };

export type MeQueryVariables = Types.Exact<{
  input: Types.ExamsSummarySelection;
}>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'MeView', username: string, email: string, id: string, recentlyUsedGroupId?: string | null, groups: Array<{ __typename?: 'GroupView', code: string, name: string, me?: { __typename?: 'GroupMemberView', memberSince: any, role: Types.GroupMemberRoleView, score: number, user: { __typename?: 'UserPublicModelView', id: string, username: string }, examsSummary: Array<{ __typename?: 'ExamResultsSummary', passedExamsNumber: number, tag: string, totalExamsNumber: number }> } | null }> } };

export type LastGroupQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LastGroupQuery = { __typename?: 'Query', me: { __typename?: 'MeView', recentlyUsedGroupId?: string | null } };

export type HeaderInfoQueryVariables = Types.Exact<{
  input: Types.JoinRequestsSelectionInput;
}>;


export type HeaderInfoQuery = { __typename?: 'Query', me: { __typename?: 'MeView', recentlyUsedGroupId?: string | null, groups: Array<{ __typename?: 'GroupView', code: string, me?: { __typename?: 'GroupMemberView', role: Types.GroupMemberRoleView, score: number } | null, joinRequests: { __typename?: 'JoinRequestViewPaginationResultSetView', total: number } }> } };


export const SignInDocument = gql`
    mutation SignIn($input: SignInInput!) {
  signIn(input: $input) {
    result {
      accessToken
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const MeDocument = gql`
    query Me($input: ExamsSummarySelection!) {
  me {
    username
    email
    id
    recentlyUsedGroupId
    groups {
      code
      name
      me {
        memberSince
        role
        user {
          id
          username
        }
        examsSummary(input: $input) {
          passedExamsNumber
          tag
          totalExamsNumber
        }
        score
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMeQuery(baseOptions: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const LastGroupDocument = gql`
    query LastGroup {
  me {
    recentlyUsedGroupId
  }
}
    `;

/**
 * __useLastGroupQuery__
 *
 * To run a query within a React component, call `useLastGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastGroupQuery(baseOptions?: Apollo.QueryHookOptions<LastGroupQuery, LastGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastGroupQuery, LastGroupQueryVariables>(LastGroupDocument, options);
      }
export function useLastGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastGroupQuery, LastGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastGroupQuery, LastGroupQueryVariables>(LastGroupDocument, options);
        }
export function useLastGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LastGroupQuery, LastGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastGroupQuery, LastGroupQueryVariables>(LastGroupDocument, options);
        }
export type LastGroupQueryHookResult = ReturnType<typeof useLastGroupQuery>;
export type LastGroupLazyQueryHookResult = ReturnType<typeof useLastGroupLazyQuery>;
export type LastGroupSuspenseQueryHookResult = ReturnType<typeof useLastGroupSuspenseQuery>;
export type LastGroupQueryResult = Apollo.QueryResult<LastGroupQuery, LastGroupQueryVariables>;
export const HeaderInfoDocument = gql`
    query headerInfo($input: JoinRequestsSelectionInput!) {
  me {
    recentlyUsedGroupId
    groups {
      code
      me {
        role
        score
      }
      joinRequests(input: $input) {
        total
      }
    }
  }
}
    `;

/**
 * __useHeaderInfoQuery__
 *
 * To run a query within a React component, call `useHeaderInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaderInfoQuery(baseOptions: Apollo.QueryHookOptions<HeaderInfoQuery, HeaderInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderInfoQuery, HeaderInfoQueryVariables>(HeaderInfoDocument, options);
      }
export function useHeaderInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderInfoQuery, HeaderInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderInfoQuery, HeaderInfoQueryVariables>(HeaderInfoDocument, options);
        }
export function useHeaderInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderInfoQuery, HeaderInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderInfoQuery, HeaderInfoQueryVariables>(HeaderInfoDocument, options);
        }
export type HeaderInfoQueryHookResult = ReturnType<typeof useHeaderInfoQuery>;
export type HeaderInfoLazyQueryHookResult = ReturnType<typeof useHeaderInfoLazyQuery>;
export type HeaderInfoSuspenseQueryHookResult = ReturnType<typeof useHeaderInfoSuspenseQuery>;
export type HeaderInfoQueryResult = Apollo.QueryResult<HeaderInfoQuery, HeaderInfoQueryVariables>;